import _ from 'utils/i18n';

import {useURL} from 'selectra/hooks';

import MenuLink from './MenuLink';

const Label = _('Imprint');

const Imprint = () => (
    <MenuLink to={useURL('imprint')}>
        {Label}
    </MenuLink>
);

export default Imprint;
